function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// --- page_scroll_nav_collapse ---

// var previous_scroll_top = 0;
// var current_scroll_top = 0;

var collapse_menu_on_scroll = function() {
  // console.log('-- collapse_menu_on_scroll --');

  // current_scroll_top = $(window).scrollTop();
  // if( current_scroll_top > previous_scroll_top ) {
  //   if(current_scroll_top > 250) {
  //     $(".nav-allow-collapse").addClass("top-nav-collapse");
  //   }
  // } else {
  //   $(".nav-allow-collapse").removeClass("top-nav-collapse");
  // }
  // previous_scroll_top = current_scroll_top;

  if ($(".nav-allow-collapse").offset().top > 50) {
      $(".nav-allow-collapse").addClass("top-nav-collapse");
  } else {
      $(".nav-allow-collapse").removeClass("top-nav-collapse");
  }
}

if($('.nav-allow-collapse').length > 0) {
  $(window).on('scroll', collapse_menu_on_scroll);

  // on page load
  collapse_menu_on_scroll();
}

// --- ./page_scroll_nav_collapse ---

// --- gigs_show_js ---
function calculate_gig_total() {
  var to_tal = parseInt($('#gig_base_price').attr('data-price'), 10);

  var services = document.getElementsByClassName("extra-service-checkbox");
  for (var i = 0; i < services.length; i++) {
    var elem = services.item(i);
    if($(elem).is(':checked')) {
      // console.log('is checked');
      to_tal = to_tal + parseInt(services.item(i).getAttribute('data-price'), 10);
    } else {
      // console.log('not checked');
    }

  }

  var ex_tra = document.getElementById("order_has_extra_fast_delivery");
  // console.log(ex_tra);
  if($(ex_tra).is(':checked')) {
    to_tal = to_tal + parseInt(ex_tra.getAttribute('data-price'), 10);
  }

  // console.log(to_tal);

  $('#gig_total_amount_usd').html(to_tal);
}

$(document).on('change', '.extra-service-checkbox', function(){
  var new_val = ($(this).is(':checked') ? 0 : 1);
  $(this).parent().find('.extra-service-destroy').val(new_val);
  calculate_gig_total();
});

$(document).on('change', '#order_has_extra_fast_delivery', function(){
  // console.log('extra!');
  calculate_gig_total();
});

//----------------

//   $('#gig-images-slider').carousel({
//     // interval: 4000
//   });

$(document).on('click', '#gig-images-slider .carousel-control-prev', function() {
  $("#gig-images-slider").carousel("prev");
});

$(document).on('click', '#gig-images-slider .carousel-control-next', function() {
  $("#gig-images-slider").carousel("next");
});
// --- ./gigs_show_js ---

function toggle_admin_nav() {
  // console.log('-- toggle_admin_nav --');
  var val = getCookie('hide-admin-nav');
  $('#admin-nav').toggle(val != 'true');
}

$(document).on('click', '#toggle-admin-nav', function(){
  // console.log('-- toggle_admin_nav -- clicked --');
  var val = $('#admin-nav').toggle().is(':hidden');
  setCookie('hide-admin-nav', val, 365);
});

// --- gig_order_message_form ---
$(document).on('keypress', '#order_message_body', function(e){
  // console.log(e.key == 'Enter');
  // console.log(e.key == 'Enter', e.ctrlKey, e.shiftKey);

  if(e.key == 'Enter' && e.shiftKey) {
    // do nothing
    // it is for new line
  } else if(e.key == 'Enter') {
    $(this).closest('form').find('.send-msg-btn').trigger('click');
    return false;
  }
});
// --- ./gig_order_message_form ---

window.setCookie = setCookie;
window.getCookie = getCookie;

//--------

// document.addEventListener('turbo:load', function(){
//   $('#gig-images-slider').carousel({
//     interval: 1000
//   });
// });

//--------

// run on every new page render
document.addEventListener('turbo:load', function(){
  var uri = window.location.pathname;
  $('.main-menu-section .nav-link[href="'+uri+'"]').addClass('active');
});

var appear_counter = async function(index, pa_rent) {
  // console.log(pa_rent.length, pa_rent);
  // pa_rent.parent().find('.counter-text').html(index);

  pa_rent.appear(async function() {
    // console.log('- this.count -', $(this).count);
    var elem = ( $(this).hasClass('counter') ? $(this) : $(this).find('.counter') );

    var fr_om = 0;
    var t_o = parseInt(elem.text());

    elem.html('0');

    if( t_o > fr_om ) {
      var steps_count = 100;
      var each_step = t_o / steps_count;
      var curr_val = 0;
      for(var i = 0; i <= steps_count; i++) {
        curr_val = parseInt( fr_om + ( each_step * i ) );
        if(i == steps_count) { curr_val = t_o; } // if it is last step
        // console.log('-- curr_val --', index, curr_val, i);
        // sleep(1000).then(() => { elem.html(curr_val) });
        await sleep(10);
        elem.html(curr_val);
      }
    }

    // console.log('Hello world');
  });
}

$(document).on('turbo:load', function(){
  $('.appear-count:visible').each(function(index){ appear_counter(index, $(this)); });
});

// init js
$(document).on('turbo:load', function(){
  // console.log('-- collapse_menu_on_scroll -- turbo load --', typeof(window.init_js), '..');
  // if( typeof(window.init_js) != 'undefined' ) { return; } // intialized, so return
  // window.init_js = "yes";

  // run only first page load
  // page_scroll_nav_collapse();
  // gigs_show_js();
  toggle_admin_nav();
  // gig_order_message_form();
});

// console.log('--- common.js --');
